import { createSelector } from '@ngrx/store';
import { selectEligibleMinorAccounts } from '@store/selectors/client-accounts/client-accounts.selectors';

export const selectMinorEligibility = createSelector(
  selectEligibleMinorAccounts,
  (eligibleMinorAccounts) => {
    return eligibleMinorAccounts.accounts.length > 0;
  },
);
